import React, { ReactNode } from "react";

// UI
import { Flex, FlexProps } from "../Flex/Flex";
import { Box } from "../Box/Box";
import { Icon } from "../Icon/Icon";
import { AlertTriangle } from "../Icons/AlertTriangle";
import { CircleCheck } from "../Icons/CircleCheck";

interface AlertBoxProps extends FlexProps {
  children: ReactNode;
  childrenContainerStyle?: FlexProps;
  status?: "success" | "info" | "warning" | "error" | "loading";
}

const statuses = {
  success: { as: CircleCheck, color: "green.500" },
  error: { as: AlertTriangle, color: "red.500" },
};

export const AlertBox = (props: AlertBoxProps) => {
  const {
    children,
    status = "success",
    childrenContainerStyle,
    ...rest
  } = props;
  return (
    <Flex
      shadow="lg"
      flexDirection="row"
      borderRadius={10}
      overflow="hidden"
      {...rest}
    >
      <Box
        bg={statuses[status]?.color}
        style={{
          width: 5,
        }}
      />
      <Flex
        flex={1}
        justifyContent="center"
        alignItems="center"
        m={4}
        {...childrenContainerStyle}
      >
        <Icon {...statuses[status]} />
        {children}
      </Flex>
    </Flex>
  );
};
